$(function() {
  $('[data-country-select]').on('change', function(e) {
    var option = $(this).find('option:selected').get(0);
    $(document).trigger('gdpr:country_selected', option.hasAttribute('data-opt-in'));
  });

  $(document).on('gdpr:country_selected', function(e, requiresOptIn) {
    $('[data-gdpr-opt-in]').toggle(requiresOptIn);
  });

  $('.js-autofocus').focus();

  $('a[rel=external]').click(function(e) {
    $(this).attr('target', '_blank');
  });

  $('button[data-confirm]').on('click', function(e) {
    if (!confirm($(this).data('confirm'))) {
      e.preventDefault();
    }
  });

  // on any form that has "data-disable-on-submit" attribute,
  // we want to disable the buttons to prevent double-submission
  $('form[data-disable-on-submit]').submit(function(e) {
    $(this)
      .find('input.submit').add('button.submit').add('input[type=submit]').add('button[type=submit]')
      .prop('disabled', true);
  });

  $('a[rel=facebox]').facebox();

  // flash message closing
  $(document).on("click", "[data-flash-close]", function(e) {
    e.preventDefault();

    $(".flash").slideUp(100);
  });

});
